import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError ,Observable } from 'rxjs';
import { Estudiante } from '../models/estudiante.model';
import { Examen } from '../models/examen.model';
import { environment } from '../../environments/environment';
import { Graduacion } from '../models/graduacion.model';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EstudianteService {
  private apiUrl = `${environment.apiUrl}/estudiantes`;

  constructor(private http: HttpClient) {}

  getEstudiantes(): Observable<Estudiante[]> {
    return this.http.get<Estudiante[]>(this.apiUrl);
  }

  getEstudiante(nroLibreta: number): Observable<Estudiante> {
    return this.http.get<Estudiante>(`${this.apiUrl}/${nroLibreta}`);
  }

  getEstudianteWithExamenes(nroLibreta: number): Observable<{estudiante: Estudiante, examenes: Examen[]}> {
    return this.http.get<any>(`${this.apiUrl}/${nroLibreta}/full`).pipe(
      map(data => ({
        estudiante: Estudiante.fromApiData(data),
        examenes: (data.examenes || []).map((e: any) => Examen.fromApiData(e))
      }))
    );
  }

  addEstudiante(estudiante: Estudiante): Observable<Estudiante> {
    return this.http.post<Estudiante>(`${this.apiUrl}/registro`, estudiante);
  }

  updateEstudiante(estudiante: Estudiante): Observable<Estudiante> {
    return this.http.put<Estudiante>(`${this.apiUrl}/${estudiante.nroLibreta}`, estudiante);
  }

  getUltimoExamen(nroLibreta: number): Observable<Examen> {
    return this.http.get<Examen>(`${this.apiUrl}/${nroLibreta}/examen`);
  }

  getGraduacion(nroLibreta: number): Observable<Graduacion> {
    return this.http.get<Graduacion>(`${this.apiUrl}/${nroLibreta}/graduacion`);
  }
  
  getEmail(nroLibreta: number): Observable<{ email: string }> {
    return this.http.get<{ email: string }>(`${this.apiUrl}/${nroLibreta}/email`);
  }

  /**
   * Search for estudiantes using filters
   * @param filters Object containing search criteria
   * @param sortBy Field to sort by
   * @param sortOrder 'asc' or 'desc'
   */
  filterEstudiantes(filters: any, sortBy?: string, sortOrder?: string): Observable<Estudiante[]> {
    let params = new HttpParams();
    
    // Add each filter to the params
    Object.keys(filters).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
        params = params.append(key, filters[key]);
      }
    });
    
    // Add sorting parameters
    if (sortBy) {
      params = params.append('sortBy', sortBy);
    }
    if (sortOrder) {
      params = params.append('sortOrder', sortOrder);
    }
    
    return this.http.get<any[]>(`${this.apiUrl}/filter`, { params })
      .pipe(
        map(data => data.map(item => Estudiante.fromApiData(item))),
        catchError(this.handleError<Estudiante[]>('filterEstudiantes', []))
      );
  }
  
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      console.error(`${operation} failed:`, error);
      return throwError(() => error);
    };
  }
}

